import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@node-space/ui-components'
import { IconList } from './IconList'

export const InfoHeader = () => {
  const { t } = useTranslation()

  return (
    <>
      <Text tag="h1" variant="heading-1" isCentered className="md:text-left">
        {t('embeddedCustomerTerms.title')}
      </Text>
      <Text tag="h3" variant="heading-3" isCentered className="md:text-left pt-3 md:pt-0">
        {t('embeddedCustomerTerms.subTitle')}
      </Text>
      <IconList
        items={[
          { iconName: 'CoinArrowOutCustom', text: t('embeddedCustomerTerms.benefits.effortless') },
          { iconName: 'Lightning', text: t('embeddedCustomerTerms.benefits.fast') },
          { iconName: 'Lock', text: t('embeddedCustomerTerms.benefits.compliant') },
        ]}
        className="hidden md:flex"
      />
    </>
  )
}
